/* global Stripe */
import { createTypes } from 'redux-action-types'
import api from '../api'
import config from '../config'

export const types = createTypes('fridge/account/',
  'CREATE',
  'CANCEL',
  'SAVE',
  'LOAD_TOKENS'
)

export const create = async (data, user) => {
  const account = await api.post('account', data)
  // TODO set token in cookie? can we?
  return {type: types.CREATE, data: {account, user}, redirect: '/'}
}

export const cancel = async () => {
  await api.delete('account')
  return {type: types.CANCEL, redirect: '/'}
}

export const save = async (data) => {
  const account = await api.put('account', data)
  return {type: types.SAVE, data: {account}}
}

export const savePaymentMethod = async ({billing_plan, ...billing_info}) => { // eslint-disable-line
  const token = await getStripeToken(billing_info)
  const account = await api.put('account', {billing_token: token, billing_plan})
  return {type: types.SAVE, data: {account}}
}

export const loadTokens = async () => {
  return {type: types.LOAD_TOKENS, data: await api.get('account/tokens')}
}

const getStripeToken = value => new Promise((resolve, reject) => {
  Stripe.setPublishableKey(config.stripeKey)
  Stripe.card.createToken({...value}, (status, response) => {
    if (response.error) {
      reject({error: response.error})
    } else {
      resolve(response.id)
    }
  })
})



// WEBPACK FOOTER //
// ./app/actions/account.js